import React from 'react'

class UrlInput extends React.Component{
	

	
	render() {
			let valueQR = this.props.valueQR;			
			let formId = this.props.formId;
			let isVisiableQR = this.props.isVisiableQR;
			let valueUrl = '<img src="https://sbqr.ru/qr/api_png_QR_text.php?qrtext=' + encodeURIComponent(valueQR) + '&id_form=' + formId + '" />';
            			
		
		
		if (isVisiableQR === false) 
			  { return null;
			  }
		else { return(
				<div>
				  <label>Скопируйте HTML-код для вставки QR-кода в Ваш сайт:</label>
				   <input className="inputelement"				 
						name="HTML_url" 
						defaultValue={valueUrl}
						>
				   </input>
				   
				</div>
				
				)
		}
	}
}
export default UrlInput